import { useMutation } from '@tanstack/react-query';
import { IProgressGPTChatModel } from 'api/models';
import { deleteProgressGPTChat } from 'api/services';

/* -------------------------------------------------------------------------------------------------
 * Hook: useDeleteUserForm
 * -----------------------------------------------------------------------------------------------*/

interface DeleteChatOptions {
    chat: IProgressGPTChatModel;
}

const useDeleteProgressGPTChatForm = (options: DeleteChatOptions) => {
    const { chat } = options;

    const deleteChatMutation = useMutation(() => deleteProgressGPTChat(chat._id));

    const submit = async () => {
        await deleteChatMutation.mutateAsync();
    };

    return {
        isLoading: deleteChatMutation.isLoading,
        submit,
    };
};
export default useDeleteProgressGPTChatForm;
